var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#23123E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8572 -15.5184C94.8572 -15.5184 68.4786 -2.95593 73.1606 28.1212C78.4134 62.967 47.9524 77.9223 27.1408 69.308C6.32909 60.6639 7.78505 28.6895 -31.7828 27.7024C-72.2072 26.7154 -80.7145 -13.5443 -80.7145 -13.5443",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3677 -24.8806C64.3677 -24.8806 52.9484 1.68004 57.0308 28.0911C61.1417 54.5021 42.671 57.6128 35.3341 54.5021C20.0894 48.1013 17.1489 13.8237 -7.45971 11.6103C-25.959 9.93536 -50.8531 23.1857 -64.0424 -6.87439",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0634 -13.0358C52.0634 -13.0358 56.1743 14.0931 37.9891 9.24758C17.1488 3.68422 17.4629 -9.35679 -8.9157 2.96636C-18.3081 7.36322 -56.106 8.64937 -48.4836 -15.5184",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8741 45.1403C43.2415 45.1403 46.782 39.6766 46.782 32.9368C46.782 26.197 43.2415 20.7333 38.8741 20.7333C34.5067 20.7333 30.9662 26.197 30.9662 32.9368C30.9662 39.6766 34.5067 45.1403 38.8741 45.1403Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6447 42.5228C46.4898 42.3297 47.8896 40.7212 47.826 38.7908C47.7625 36.8606 46.1717 35.3163 44.2629 35.3163H44.1357C42.1631 35.3807 40.6361 37.0536 40.6998 39.0481C40.7635 40.0133 41.1451 40.8498 41.7178 41.4288C39.5545 45.7399 36.2459 48.8927 31.283 51.5307C27.9107 53.3324 24.4113 53.9758 20.9119 53.5255C18.0486 53.1394 15.8217 51.8527 14.4217 49.7291C12.3857 46.5764 12.1949 43.1661 13.9129 39.756C15.1219 37.3109 17.0305 35.5093 18.2394 34.6085C17.985 33.772 17.6031 32.3565 17.4123 31.3271C8.18633 38.0831 9.14082 47.2198 11.9404 51.5307C14.04 54.7481 18.3031 56.7427 23.0115 56.7427C24.284 56.7427 25.5564 56.6139 26.8291 56.2923C34.9734 54.6837 41.1453 49.7935 44.6447 42.5228V42.5228ZM55.8432 34.5443C51.0074 28.8177 43.8812 25.6649 35.7369 25.6649H34.7189C34.1463 24.5068 32.9373 23.7345 31.6012 23.7345H31.4738C29.5016 23.7989 27.9746 25.4718 28.0381 27.4666C28.1018 29.3968 29.6924 30.941 31.6012 30.941H31.7283C33.1281 30.8766 34.3371 29.9758 34.8461 28.7533H35.9914C40.8271 28.7533 45.4082 30.1688 49.5441 32.9356C52.7254 35.059 55.016 37.8258 56.2885 41.1715C57.3701 43.8739 57.3064 46.512 56.1611 48.7641C54.3797 52.1742 51.3892 54.0402 47.4443 54.0402C44.8992 54.0402 42.4814 53.268 41.2088 52.6889C40.509 53.3324 39.2363 54.3618 38.3455 55.0054C41.0816 56.2922 43.8812 57 46.5535 57C52.6617 57 57.1793 53.5897 58.8973 50.1796C60.7424 46.4476 60.615 40.0133 55.8432 34.5443V34.5443ZM23.5205 43.6164C23.5842 45.5468 25.1748 47.0909 27.0836 47.0909H27.2109C29.1834 47.0267 30.7103 45.3536 30.6467 43.359C30.5832 41.4286 28.9924 39.8846 27.0836 39.8846H26.9564C26.8291 39.8846 26.6381 39.8846 26.5111 39.9488C23.9023 35.5735 22.8207 30.8123 23.2025 25.6647C23.4568 21.8041 24.7295 18.4582 26.9564 15.6914C28.8016 13.3107 32.3646 12.1525 34.7826 12.0884C41.5269 11.9596 44.39 20.4528 44.581 23.8631C45.4082 24.0561 46.808 24.5066 47.7625 24.8283C46.9988 14.4049 40.6361 9 34.5281 9C28.8016 9 23.5205 13.1823 21.4207 19.3592C18.4939 27.5951 20.4027 35.5093 23.9658 41.7506C23.6478 42.2009 23.4568 42.9087 23.5205 43.6166V43.6164Z",
    fill: "#BF9EF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.058631a41390e4bd850a78278ef08240.svg";
export { ForwardRef as ReactComponent };